import type { PokemonV2 } from '../pokemon/pokemon';
import { getArceusEffectiveType } from '../pokemon/PlateUtils';
import {
  POKEMON_TYPE_NORMAL,
  POKEMON_TYPE_STERA,
  type PokemonType,
} from '../types/type';

// めざめるダンス（Revelation Dance）の攻撃タイプを決定する
// - 通常時: 使用者のタイプ1で攻撃する
// - テラスタル時: テラスタイプで攻撃する（ステラは除く）
// - ステラテラス時: 攻撃するタイプは変わらない（タイプ1のまま）
export const resolveRevelationDanceMoveType = (
  pokemon: Pick<
    PokemonV2,
    'id' | 'species_id' | 'type_id_list' | 'selected_item_id' | 'terasu_type'
  >,
): PokemonType => {
  if (pokemon.terasu_type && pokemon.terasu_type !== POKEMON_TYPE_STERA) {
    return pokemon.terasu_type;
  }

  // アルセウスはプレートで実効タイプが変わるため、タイプ1の取得にも反映する
  const effectiveTypes = getArceusEffectiveType(pokemon);
  const type1 = effectiveTypes[0] as PokemonType | undefined;
  return type1 ?? POKEMON_TYPE_NORMAL;
};

